import React from 'react';
import Container from '../../components/container/Container';
import { useTranslation } from 'react-i18next';
import { exitApp } from '../../hooks/utils';
import { mutationKeys, useStoredInvitationMutation, useSendOtpMutation } from '../../hooks/mutationHooks';
import { useHistory } from 'react-router';
import BackButton from '../../components/buttons/BackButton';
import { useMutationState } from '@tanstack/react-query';
import { useSettings } from '../../hooks/queryHooks';

const VerifyNumber = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { settings } = useSettings();
  const { mutate } = useSendOtpMutation();

  const [data] = useMutationState({
    filters: { mutationKey: [mutationKeys.createStoredUserMutation] },
    select: mutation => mutation.state.data
  }) as Array<ReturnType<typeof useStoredInvitationMutation>['data']>;

  return (
    <Container
      primaryBtn={{
        text: t('Continue'),
        onClick: () => {
          mutate();
          history.push('/otp');
        }
      }}
      {...(settings?.redirectUrl && {
        secondaryBtn: {
          text: t('Abort & return to partner'),
          onClick: () => exitApp()
        }
      })}
    >
      <BackButton />
      <h1 className="uppercase text-md sm:text-lg mb-2 font-semi-bold text-primary-2">{t('Verify identity')}</h1>
      <p className="text-base text-primary-2">
        {t('We will send a verification code to your phone number:')} <strong>{data?.maskedPhoneNumber}</strong>
      </p>
    </Container>
  );
};

export default VerifyNumber;
